import React, { useEffect, useState } from "react";
import {
  getApScores,
  getOverviewTexts,
  saveOverviewTexts,
} from "../../../lib/studentgparigorsummary";
import style from "./globalstudentgparigorsummary.module.css";
import { Toast, ToastContainer } from "react-bootstrap";

const SCORE_VALUES = [5, 4, 3, 2, 1];

export default function GlobalStudentApScoreSummary({
  studentId,
  isStudent = false,
}) {
  const [scoreCounts, setScoreCounts] = useState({});
  const [overview, setOverview] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [collapseOpenClose, setCollapseOpenClose] = useState(true);

  const collapseAll = () => {
    setCollapseOpenClose(!collapseOpenClose);
  };

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const data = await getApScores(studentId);
    const overviewData = await getOverviewTexts(studentId);

    const scoreMap = {};
    data.forEach(({ apscore, count }) => {
      scoreMap[apscore] = count;
    });

    const overviewText =
      overviewData.find((item) => item.type === "capscore")?.desc || "";
    setScoreCounts(scoreMap);
    setOverview(overviewText);
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, { capscore: overview });
    setShowToast(true);
    loadData();
  };

  const getTotalCount = () =>
    SCORE_VALUES.reduce((sum, score) => sum + (scoreCounts[score] || 0), 0);

  const getAverageScore = () => {
    const total = getTotalCount();
    if (total === 0) return "-";

    const weightedSum = SCORE_VALUES.reduce(
      (sum, score) => sum + score * (scoreCounts[score] || 0),
      0
    );

    return (weightedSum / total).toFixed(2);
  };

  return (
    <div className="card p-3">
      <div className="personal-info-head">
        <h4>
          AP Scores{" "}
          {/* <button
            type="button"
            className="btn btn-outline-info ms-2"
            data-bs-toggle="collapse"
            data-bs-target="#apScoreCollapse"
            aria-expanded="false"
            onClick={() => collapseAll()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              fill="currentColor"
              className="bi bi-chevron-double-down"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
              />
              <path
                fillRule="evenodd"
                d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
              />
            </svg>
          </button> */}
        </h4>
        <ToastContainer
          style={{ top: "1rem", right: "1rem", position: "fixed" }}
          className="p-3"
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Overview updated successfully</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      <div className={`collapse ${collapseOpenClose ? "show" : ""}`}>
        <table className="table table-bordered text-center">
          <thead>
            <tr>
              <th>Score</th>
              <th>Count</th>
              <th>Overview</th>
            </tr>
          </thead>
          <tbody>
            {SCORE_VALUES.map((score, index) => (
              <tr key={score}>
                <td>{score}</td>
                <td>{scoreCounts[score] || 0}</td>
                {index === 0 && (
                  <td rowSpan={SCORE_VALUES.length + 2}>
                    {!isStudent ? (
                      <textarea
                        rows={10}
                        className="form-control h-100"
                        value={overview}
                        onChange={(e) => setOverview(e.target.value)}
                        style={{ resize: "none" }}
                      />
                    ) : (
                      <div className="bg-light border rounded p-2 h-100">
                        {overview}
                      </div>
                    )}
                  </td>
                )}
              </tr>
            ))}
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td>{getTotalCount()}</td>
            </tr>
            <tr>
              <td>
                <strong>Avg</strong>
              </td>
              <td className={style.totalCell}>{getAverageScore()}</td>
            </tr>
          </tbody>
        </table>

        {!isStudent && (
          <div className="text-end">
            <button className="btn btn-primary" onClick={handleUpdate}>
              Update
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
